<template>
	<div class="c c-swiper__items">
		<template v-if="isLoading">
			<div class="c-articles__item c-placeholder"></div>
			<div class="c-swiper__nav--placeholder"></div>
		</template>
		<div v-else class="c-swiper__swiper swiper-container">
			<div class="swiper-wrapper">
				<a
					v-for="resultItem in searchResults"
					:key="resultItem.DocumentGuid"
					:href="resultItem.DocumentUrl"
					:title="resultItem.Title"
					:class="['swiper-slide c-swiper__item c-articles__item', resultItem.PhotoUrl ? 'has-image' : 'no-image']"
				>
					<div v-if="resultItem.PhotoUrl" class="c-articles__image">
						<img :src="resultItem.PhotoUrl" alt="" class="c-articles__image--img" loading="lazy" />
					</div>
					<div class="c-articles__labels c-labels">
						<div v-if="overviewSettings.SectorList === 'Bedrijfsontwikkeling'" class="c-labels__lbl" data-type="sector">Bedrijfsontwikkeling</div>
						<div v-else-if="resultItem.SectorLabel !== null" class="c-labels__lbl" data-type="sector">{{ resultItem.SectorLabel }}</div>
						<div v-for="sector in resultItem.Sector.filter((sector) => sector.includes('.') != true)" v-else :key="sector" class="c-labels__lbl" data-type="sector">{{ sector }}</div>
						<div v-for="theme in resultItem.Theme" :key="theme" class="c-labels__lbl" data-type="theme">{{ theme }}</div>
					</div>
					<div class="c-articles__inner">
						<div v-if="resultItem.ArticleType === 'News'" class="c-articles__date">{{ getPresentationDate(resultItem.DocumentDate) }}</div>
						<div class="h3 c-articles__title">{{ resultItem.Title }}</div>
						<div class="c-articles__text">
							<p>{{ resultItem.Intro }}</p>
							<div class="c-articles__readmore"><span>Lees verder</span><i class="fal fa-arrow-right"></i></div>
						</div>
					</div>
				</a>
			</div>
			<div class="c-swiper__nav">
				<div class="swiper-scrollbar"></div>
				<div class="c-swiper__nav--arrow" data-type="prev"><i class="fal fa-arrow-left"></i></div>
				<div class="c-swiper__nav--arrow" data-type="next"><i class="fal fa-arrow-right"></i></div>
			</div>
		</div>
	</div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import azuresearch, { AzureSearchApiSettings, AzureSearchRequest, AzureSearchGui, AzureSearchFacetDefinition, AzureSearchSearchSettings, AzureSearchApi } from '@frontisbv/scheffer-azuresearch-searchclient';
// import _ from 'lodash';
import Swiper from 'swiper';

export default {
	// eslint-disable-next-line vue/require-prop-types
	props: ['azureSearchSettings', 'overviewSettings'],
	data() {
		return {
			searchRequest: null,
			searchRequestFilter: '',
			searchRequestSearchParam: '*',
			searchResults: [],
			count: 0,
			isLoading: true
		};
	},
	async created() {
		this.searchApi = this.setSearchApi();
		this.searchRequest = this.setSearchQuery();
		await this.search();
	},
	updated() {
		new Swiper('.c-swiper__swiper', {
			loop: false,
			autoplay: false,
			spaceBetween: 20,
			slidesPerView: 'auto',
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			watchOverflow: true,
			pagination: false,
			speed: 600,
			navigation: {
				nextEl: '.c-swiper__nav--arrow[data-type="next"]',
				prevEl: '.c-swiper__nav--arrow[data-type="prev"]'
			},
			scrollbar: {
				el: '.swiper-scrollbar',
				hide: false,
				draggable: true
			},
			breakpoints: {
				768: {
					spaceBetween: 40
				},
				1280: {
					spaceBetween: 60
				}
			}
		});
	},
	methods: {
		async search() {
			this.addFiltersToSearchRequest();

			this.searchRequest.search = this.searchRequestSearchParam;
			this.searchRequest.filter = this.searchRequestFilter;
			this.searchRequest.skip = 0;

			try {
				var response = await this.searchApi.search(this.searchRequest);
				this.searchResults = response.data.value;
				this.count = response.data['@odata.count'];
			} catch (e) {
				console.error(e);
			}

			this.isLoading = false;
		},
		setSearchApi: function () {
			const settings = new azuresearch.AzureSearchSearchSettings({
				apiSettings: {
					searchServiceName: this.azureSearchSettings.ServiceName,
					searchServiceQueryApiKey: this.azureSearchSettings.ServiceQueryApiKey,
					indexName: this.overviewSettings.IndexName,
					apiVersion: this.azureSearchSettings.ApiVersion,
					url: this.azureSearchSettings.Url
				}
			});

			return new azuresearch.AzureSearchApi(settings);
		},
		setSearchQuery: function () {
			var result = new azuresearch.AzureSearchRequest({
				search: this.searchRequestSearchParam,
				select: this.overviewSettings.ColumnNames,
				top: this.overviewSettings.PageSize,
				skip: 0,
				count: true,
				orderBy: this.overviewSettings.OrderBy ? this.overviewSettings.OrderBy : null
			});

			return result;
		},
		addFiltersToSearchRequest: function () {
			this.searchRequestFilter = "(ArticleType ne 'Product')";

			if (this.overviewSettings.SectorList != null) {
				var sectors = this.overviewSettings.SectorList.includes(',') ? this.overviewSettings.SectorList.split(',') : [this.overviewSettings.SectorList];

				if (sectors.length > 0) {
					let searchRequestFilterSectors = '';
					// for example " and (Sector/any(sector: sector eq 'Rundvee') or Sector/any(sector: sector eq 'Varkens'))"

					for (var sectorKey in sectors) {
						if (searchRequestFilterSectors !== '') searchRequestFilterSectors += ' or ';

						searchRequestFilterSectors += "Sector/any(sector: sector eq '" + sectors[sectorKey] + "')";
					}

					this.searchRequestFilter += ' and (' + searchRequestFilterSectors + ')';
				}

				var excludedGuid = this.overviewSettings.ExcludedGuid;

				if (excludedGuid != null && excludedGuid !== '') {
					this.searchRequestFilter += "and DocumentGuid ne '" + excludedGuid + "'";
				}
			}
		},
		getPresentationDate: function (dateString) {
			const unixTimestamp = Date.parse(dateString);

			var a = new Date(unixTimestamp);
			var months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
			var year = a.getFullYear();
			var month = months[a.getMonth()];
			var day = a.getDate();

			return day + ' ' + month + ' ' + year;
		}
	}
};
</script>
